import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { MarkenFilterDto } from '../Mza/Entities/Dtos/markenfilterdto.entity';
import { MarkeDto } from '../entities/produkte/markedto.entity';
//#endregion

@Injectable()
export class MarkenService extends ODataEntityService<MarkeDto> {
  constructor(protected client: ODataClient) {
    super(client, 'Marken', 'entities.produkte.MarkeDto');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  public inputFilter(): ODataFunctionResource<{value: string}, MarkenFilterDto> {
    const resource = this.entities().function<{value: string}, MarkenFilterDto>('services.InputFilter');
    return resource;
  }
  //#endregion
  //#region ODataApi Navigations
  //#endregion
}
